interface Props {
  width?: number;
  height?: number;
}

export default function NotFoundSVG({ width = 325, height = 300 }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 325 300'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_7257_56705'
        maskUnits='userSpaceOnUse'
        x='92'
        y='67'
        width='237'
        height='237'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M92.0823 67.4314H328.651V304H92.0823V67.4314Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M92.0823 185.716C92.0823 251.042 145.04 304 210.367 304C275.693 304 328.651 251.042 328.651 185.716C328.651 120.389 275.693 67.4314 210.367 67.4314C145.04 67.4314 92.0823 120.389 92.0823 185.716Z'
          fill='#E9EEFF'
        />
      </g>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M243.271 244.704C242.912 249.585 242 264.823 250.325 277.155C251.717 279.217 255.067 284.074 258.147 283.478C261.928 282.745 263.344 274.227 263.683 270.81C264.774 259.824 263.032 224.951 258.562 177.934C253.519 191.989 245.247 217.901 243.271 244.704Z'
        fill='#393B41'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M243.271 244.704C242.912 249.585 242 264.823 250.325 277.155C251.717 279.217 255.067 284.074 258.147 283.478C261.928 282.745 263.344 274.227 263.683 270.81C264.774 259.824 263.032 224.951 258.562 177.934C253.519 191.989 245.247 217.901 243.271 244.704Z'
        stroke='#393B41'
        stroke-width='1.41949'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <mask
        id='mask1_7257_56705'
        maskUnits='userSpaceOnUse'
        x='132'
        y='142'
        width='133'
        height='119'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M139.829 155.956C139.754 156.203 138.877 159.134 139.99 162.125C137.95 165.031 136.355 168.64 136.738 172.559C137.307 178.468 142.227 183.697 148.717 187.048C147.568 187.333 133.71 191.017 132.535 199.583C132.485 199.942 132.201 202.278 133.339 204.665C134.81 207.743 138.271 210.067 142.734 211.624C141.621 212.515 137.53 215.952 136.998 221.49C136.602 225.434 138.172 228.821 139.434 230.515C142.4 234.533 148.89 236.189 156.074 236.127C154.8 237.215 153.712 238.451 152.846 239.823C152.006 241.171 150.201 244.039 150.856 247.29C151.104 248.514 152.674 254.572 169.573 258.528C188.067 262.868 201.704 259.245 217.07 257.317C227.863 255.956 243.897 254.869 264.171 257.057L260.907 179.111C247.098 171.459 245.578 165.797 232.808 157.625C212.705 144.755 192.506 143.445 185.533 143.075C183.717 142.979 181.739 142.925 179.658 142.925C164.288 142.925 143.237 145.831 139.829 155.956Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M139.829 155.956C139.754 156.203 138.877 159.134 139.99 162.125C137.95 165.031 136.355 168.64 136.738 172.559C137.307 178.468 142.227 183.697 148.717 187.048C147.568 187.333 133.71 191.017 132.535 199.583C132.485 199.942 132.201 202.278 133.339 204.665C134.81 207.743 138.271 210.067 142.734 211.624C141.621 212.515 137.53 215.952 136.998 221.49C136.602 225.434 138.172 228.821 139.434 230.515C142.4 234.533 148.89 236.189 156.074 236.127C154.8 237.215 153.712 238.451 152.846 239.823C152.006 241.171 150.201 244.039 150.856 247.29C151.104 248.514 152.674 254.572 169.573 258.528C188.067 262.868 201.704 259.245 217.07 257.317C227.863 255.956 243.897 254.869 264.171 257.057L260.907 179.111C247.098 171.459 245.578 165.797 232.808 157.625C212.705 144.755 192.506 143.445 185.533 143.075C183.717 142.979 181.739 142.925 179.658 142.925C164.288 142.925 143.237 145.831 139.829 155.956Z'
          fill='url(#paint0_linear_7257_56705)'
        />
      </g>
      <path
        d='M232.343 217.511C228.679 216.174 223.173 213.626 217.815 208.736C209.334 200.994 206.195 191.918 205.039 187.741'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <mask
        id='mask2_7257_56705'
        maskUnits='userSpaceOnUse'
        x='257'
        y='177'
        width='72'
        height='122'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M257.21 177.935H328.651V298.465H257.21V177.935Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M328.651 185.716L322.115 298.465C300.555 292.707 285.325 289.653 275.311 287.432C269.245 286.085 263.211 284.777 257.21 283.509C257.255 283.511 257.388 283.518 257.529 283.516C257.645 283.526 257.759 283.518 257.873 283.511C257.969 283.507 258.073 283.491 258.15 283.472C261.922 282.745 263.343 274.232 263.682 270.81C264.775 259.826 263.036 224.955 258.566 177.935L328.651 185.716Z'
          fill='#3B61EB'
        />
      </g>
      <path
        d='M273.629 287.059V287.059C279.025 280.037 281.878 271.391 281.718 262.537L280.236 180.341'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <path
        d='M250.325 277.155C251.717 279.217 255.067 284.074 258.147 283.478C261.928 282.745 263.344 274.227 263.683 270.81C264.774 259.825 263.032 224.951 258.561 177.934'
        stroke='#393B41'
        stroke-width='1.41949'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M171.531 119.343C166.468 122.592 161.287 124.344 156.514 125.186C151.734 125.979 146.265 126.049 140.41 124.668C125.691 121.179 111.63 109.149 108.839 92.4058C106.807 80.161 111.251 68.0876 118.408 60.2156C124.614 53.3844 133.365 49.0402 143.226 47.5161C153.045 45.6734 162.73 46.8629 170.854 51.2426C180.233 56.2855 188.425 66.1961 190.579 78.4201C193.528 95.1361 184.266 111.157 171.531 119.343ZM184.514 39.9627C171.991 30.7674 155.94 27.5561 140.298 30.4076L139.628 30.5226C124.213 33.1601 110.409 41.4665 101.787 54.1172C89.5765 72.0344 89.4224 96.2041 100.129 114.064C110.303 131.068 129.729 141.362 150.895 141.673C153.694 161.02 160.993 213.57 161.972 219.486C162.74 224.124 167.239 227.173 171.831 226.166C171.885 226.153 171.941 226.141 171.995 226.13C176.342 225.176 179.138 220.935 178.301 216.564C177.335 211.518 169.102 152.849 166.942 138.999C175.724 135.817 183.545 130.918 189.893 124.768C198.037 116.878 203.773 106.928 206.008 95.9483C210.168 75.5455 201.987 52.8016 184.514 39.9627Z'
        fill='#C5E79F'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M171.531 119.343C166.468 122.592 161.287 124.344 156.514 125.186C151.734 125.979 146.265 126.049 140.41 124.668C125.691 121.179 111.63 109.149 108.839 92.4058C106.807 80.161 111.251 68.0876 118.408 60.2156C124.613 53.3844 133.365 49.0402 143.226 47.5161C153.044 45.6734 162.73 46.8629 170.854 51.2426C180.233 56.2855 188.425 66.1961 190.579 78.4201C193.528 95.1361 184.266 111.157 171.531 119.343Z'
        stroke='#393B41'
        stroke-width='1.41949'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <mask
        id='mask3_7257_56705'
        maskUnits='userSpaceOnUse'
        x='150'
        y='230'
        width='40'
        height='27'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M153.088 240.142C152.381 241.266 150.398 244.215 151.095 247.602C152.015 252.07 156.937 254.257 158.243 254.838C166.077 258.32 174.333 254.243 177.378 252.739C180.453 251.22 189.082 246.958 189.255 240.257C189.336 237.108 187.515 234.796 187.3 234.531C184.863 231.525 180.109 230.067 174.823 230.067C166.669 230.066 157.245 233.535 153.088 240.142Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask3_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M153.088 240.142C152.381 241.266 150.398 244.215 151.095 247.602C152.015 252.07 156.937 254.257 158.243 254.838C166.077 258.32 174.333 254.243 177.378 252.739C180.453 251.22 189.082 246.958 189.255 240.257C189.336 237.108 187.515 234.796 187.3 234.531C184.863 231.525 180.109 230.067 174.823 230.067C166.669 230.066 157.245 233.535 153.088 240.142Z'
          fill='url(#paint1_linear_7257_56705)'
        />
      </g>
      <mask
        id='mask4_7257_56705'
        maskUnits='userSpaceOnUse'
        x='137'
        y='206'
        width='49'
        height='31'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M142.974 211.942C141.719 213.032 137.761 216.469 137.229 221.799C136.849 225.591 138.337 229.025 139.669 230.824C147.869 241.899 182.76 235.035 185.332 223.73C186.043 220.599 184.756 215.018 181.074 212.073C179.541 210.848 178.003 210.404 177.116 210.169C171.734 208.742 164.894 206.928 158.237 206.929C152.709 206.929 147.307 208.18 142.974 211.942Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask4_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M142.974 211.942C141.719 213.032 137.761 216.469 137.229 221.799C136.849 225.591 138.337 229.025 139.669 230.824C147.869 241.899 182.76 235.035 185.332 223.73C186.043 220.599 184.756 215.018 181.074 212.073C179.541 210.848 178.003 210.404 177.116 210.169C171.734 208.742 164.894 206.928 158.237 206.929C152.709 206.929 147.307 208.18 142.974 211.942Z'
          fill='url(#paint2_linear_7257_56705)'
        />
      </g>
      <mask
        id='mask5_7257_56705'
        maskUnits='userSpaceOnUse'
        x='132'
        y='186'
        width='52'
        height='29'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M148.959 187.358C146.208 188.2 133.886 191.972 132.772 199.897C132.415 202.439 133.339 204.494 133.572 204.98C139.348 217.056 175.784 217.576 182.438 205.142C182.766 204.529 184.507 201.11 183.473 197.436C182.231 193.022 177.718 190.856 174.316 189.281C168.863 186.757 163.47 186.03 159.064 186.03C153.497 186.03 149.506 187.191 148.959 187.358Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask5_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M148.959 187.358C146.208 188.2 133.886 191.972 132.772 199.897C132.415 202.439 133.339 204.494 133.572 204.98C139.348 217.056 175.784 217.576 182.438 205.142C182.766 204.529 184.507 201.11 183.473 197.436C182.231 193.022 177.718 190.856 174.316 189.281C168.863 186.757 163.47 186.03 159.064 186.03C153.497 186.03 149.506 187.191 148.959 187.358Z'
          fill='url(#paint3_linear_7257_56705)'
        />
      </g>
      <mask
        id='mask6_7257_56705'
        maskUnits='userSpaceOnUse'
        x='136'
        y='163'
        width='48'
        height='29'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M155.814 164.054L139.039 164.313C138.185 165.833 137.504 167.495 137.162 169.255C136.935 170.421 136.857 171.631 136.977 172.871C138.161 185.124 158.046 194.427 171.762 190.205C173.137 189.783 181.645 187.164 183.003 180.685C184.501 173.543 176.117 167.391 175.219 166.749C171.148 163.843 166.67 163.062 163.02 163.062C159.417 163.062 156.62 163.823 155.814 164.054Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask6_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M155.814 164.054L139.039 164.313C138.185 165.833 137.504 167.495 137.162 169.255C136.935 170.421 136.857 171.631 136.977 172.871C138.161 185.124 158.046 194.427 171.762 190.205C173.137 189.783 181.645 187.164 183.003 180.685C184.501 173.543 176.117 167.391 175.219 166.749C171.148 163.843 166.67 163.062 163.02 163.062C159.417 163.062 156.62 163.823 155.814 164.054Z'
          fill='url(#paint4_linear_7257_56705)'
        />
      </g>
      <path
        d='M177.386 252.736C184.507 250.139 189.167 245.304 189.264 240.254C189.271 239.84 189.285 236.965 187.309 234.529C185.613 232.438 182.797 231.095 179.46 230.472'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <path
        d='M177.125 210.167C178.224 210.44 179.688 210.969 181.082 212.071C184.9 215.088 186.031 220.691 185.34 223.728C183.508 231.782 165.27 237.583 151.968 236.246'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <path
        d='M174.326 189.279C175.33 189.596 181.94 191.788 183.481 197.434C184.47 201.055 182.888 204.315 182.447 205.14C176.872 215.558 150.386 216.882 138.548 209.933'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <path
        d='M178.783 169.869C181.249 172.465 183.91 176.395 183.012 180.683C181.654 187.162 173.145 189.781 171.77 190.204C162.96 192.914 151.605 190.046 144.294 184.4'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <mask
        id='mask7_7257_56705'
        maskUnits='userSpaceOnUse'
        x='139'
        y='143'
        width='123'
        height='38'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M140.069 156.266C139.977 156.539 138.951 159.992 140.554 163.234C143.74 169.676 154.814 170.186 164.597 170.522C170.542 170.727 174.469 170.363 177.662 170C182.009 169.506 184.996 169.012 189.862 169.949C198.703 171.651 205.211 176.437 209.237 180.084L261.138 179.423C247.332 171.775 245.819 166.113 233.039 157.935C212.94 145.075 192.745 143.761 185.767 143.39C183.943 143.293 181.958 143.239 179.866 143.239C164.5 143.239 143.472 146.148 140.069 156.266Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask7_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M140.069 156.266C139.977 156.539 138.951 159.992 140.554 163.234C143.74 169.676 154.814 170.186 164.597 170.522C170.542 170.727 174.469 170.363 177.662 170C182.009 169.506 184.996 169.012 189.862 169.949C198.703 171.651 205.211 176.437 209.237 180.084L261.138 179.423C247.332 171.775 245.819 166.113 233.039 157.935C212.94 145.075 192.745 143.761 185.767 143.39C183.943 143.293 181.958 143.239 179.866 143.239C164.5 143.239 143.472 146.148 140.069 156.266Z'
          fill='url(#paint5_linear_7257_56705)'
        />
      </g>
      <path
        d='M209.246 180.082C205.22 176.436 198.711 171.649 189.871 169.946C181.431 168.321 178.643 171.003 164.606 170.521C154.822 170.184 143.749 169.674 140.563 163.231C138.959 159.99 139.986 156.538 140.078 156.264'
        stroke='#393B41'
        stroke-width='1.41949'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M85.1082 142.583L66.4624 147.58L74.0541 175.914L64.0006 178.608L56.4081 150.273L1.5673 164.968L0 159.118L12.1514 65.539L23.1197 62.6003L10.7326 153.108L54.0571 141.499L44.1423 97.9161L52.5512 95.6628L64.1107 138.804L82.7565 133.808L85.1082 142.583Z'
        fill='#FFCD69'
      />
      <mask
        id='mask8_7257_56705'
        maskUnits='userSpaceOnUse'
        x='233'
        y='0'
        width='86'
        height='117'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M233.626 0H318.734V116.008H233.626V0Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask8_7257_56705)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M318.734 79.983L300.089 84.9791L307.681 113.314L297.627 116.008L290.034 87.6731L235.194 102.368L233.626 96.5184L245.778 2.93859L256.747 -9.15527e-05L244.359 90.5072L287.683 78.8982L277.769 35.3157L286.177 33.0631L297.738 76.2042L316.383 71.2081L318.734 79.983Z'
          fill='#FFCD69'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_7257_56705'
          x1='408.241'
          y1='78.9651'
          x2='133.333'
          y2='78.9651'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_7257_56705'
          x1='237.05'
          y1='216.766'
          x2='159.757'
          y2='216.766'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_7257_56705'
          x1='231.177'
          y1='198.668'
          x2='155.76'
          y2='198.668'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_7257_56705'
          x1='227.175'
          y1='179.229'
          x2='151.441'
          y2='179.229'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_7257_56705'
          x1='230.259'
          y1='151.154'
          x2='144.894'
          y2='151.154'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_7257_56705'
          x1='347.77'
          y1='134.569'
          x2='169.119'
          y2='134.569'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
      </defs>
    </svg>
  );
}
